export default {
	state: {
		configId: "",
		toggles: [],
		overrides: [],
	},
	mutations: {
		SET_FEATURE_TOGGLE_BUCKET_CONFIG: (state, config) => {
			state.configId = config.configId;
			state.toggles = config.toggles;
		},
		SET_FEATURE_TOGGLE_BUCKET_OVERRIDES: (state, overrides) => {
			state.overrides = overrides;
		},
	},
	getters: {
		allToggles: (state) => {
			const all = {};
			state.toggles.forEach((toggleKey) => {
				all[toggleKey] = {
					toggleKey,
					value: 1,
					source: "config",
				};
			});

			state.overrides
				.filter((override) => override.source === "localstorage")
				.forEach((override) => {
					all[override.toggleKey] = {
						toggleKey: override.toggleKey,
						value: override.value,
						source: override.source,
					};
				});

			state.overrides
				.filter((override) => override.source === "url")
				.forEach((override) => {
					all[override.toggleKey] = {
						toggleKey: override.toggleKey,
						value: override.value,
						source: override.source,
					};
				});

			return Object.values(all).sort((a, b) => a.toggleKey - b.toggleKey);
		},
	},
};
